import React, {
  createContext,
  useCallback,
  useState,
  ReactNode,
  useRef,
} from "react"

export type VideoModalContextData = {
  handleCloseVideoModal: () => void
  handleOpenVideoModal: (url: string) => void
  isVideoModalOpen: boolean
  videoUrl: string
}

interface VideoModalProviderProps {
  children: ReactNode
}

const VideoModalContext = createContext({} as VideoModalContextData)

const VideoModalProvider = ({ children }: VideoModalProviderProps) => {
  const [isVideoModalOpen, setVideoModalOpen] = useState(false)
  const [videoUrl, setVideoUrl] = useState("")
  const isClosing = useRef<boolean>(false)

  const handleOpenVideoModal = useCallback((url: string) => {
    setVideoModalOpen(true)
    setVideoUrl(url)
  }, [])

  const handleCloseVideoModal = useCallback(() => {
    if (!isVideoModalOpen) return
    isClosing.current = true
    setTimeout(() => {
      if (isVideoModalOpen) {
        isClosing.current = false
        setVideoModalOpen(false)
        setVideoUrl("")
      }
    }, 100)
  }, [isVideoModalOpen])

  return (
    <VideoModalContext.Provider
      value={{
        isVideoModalOpen,
        handleOpenVideoModal,
        handleCloseVideoModal,
        videoUrl,
      }}
    >
      {children}
    </VideoModalContext.Provider>
  )
}

export { VideoModalProvider, VideoModalContext }
